import { Progress } from '@agro-club/agroclub-shared'
import { Bid, BidStatus } from 'modules/domain/bid/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { useEffect, useState } from 'react'

export type UserBidsObj = {
  archivedBids: Bid[]
  publishedBids: Bid[]
  potentialBids: Bid[]
  progress: Progress
  refetch: () => void
}

export const useUserBids = (userId: string): UserBidsObj => {
  const [archivedBids, setArchivedBids] = useState<Bid[]>([])
  const [publishedBids, setPublishedBids] = useState<Bid[]>([])
  const [potentialBids, setPotentialBids] = useState<Bid[]>([])
  const [progress, setProgress] = useState(Progress.IDLE)

  const fetchBids = () => {
    setProgress(Progress.WORK)
    const publishedBids = apiClient.get<Bid[]>(endpoints.userBids(userId, BidStatus.published))
    const archivedBids = apiClient.get<Bid[]>(endpoints.userBids(userId, BidStatus.archived))
    const potentialBids = apiClient.get<Bid[]>(endpoints.userPotentialBidList(userId))

    Promise.all([publishedBids, archivedBids, potentialBids])
      .then((values) => {
        setProgress(Progress.SUCCESS)
        setPublishedBids(values[0])
        setArchivedBids(values[1])
        setPotentialBids(values[2])
      })
      .catch((e) => {
        setProgress(Progress.ERROR)
        console.error(e)
      })
  }

  useEffect(() => {
    fetchBids()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return { archivedBids, publishedBids, potentialBids, progress, refetch: fetchBids }
}
